<template>
  <div v-if="(campanhas && campanhas.length > 0) && !campanhasLoading" class="wrapper-sm no-padder m-b">
    <email-view ref="emailView" />
    <div class=" bg-black">
      <div class="wrapper-sm bg-dark font-bold text-uppercase">Envios de cobranças</div>
      <div class="bg-black pos-rlt" id="tableLancesHead">
        <table class="table table-black bg-black m-b-none">
          <thead>
          <tr>
            <th style="width: 20%">Data</th>
            <th style="width: 20%">Campanha</th>
            <th style="width: 20%">E-mail enviado</th>
            <th style="width: 20%"></th>
          </tr>
          </thead>
        </table>
      </div>
      <div class="scroll-black scroll-lote">
        <table class="table table-black" id="tableLances" style="margin-top: -36px">
          <thead>
          <tr>
            <th style="width: 20%">Data</th>
            <th style="width: 20%">Campanha</th>
            <th style="width: 20%">E-mail enviado</th>
            <th style="width: 20%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="campanha in campanhas">
            <td>{{campanha.data ? campanha.data.date : '-'}}</td>
            <td>{{campanha.campanha || 'Cobrança'}}</td>
            <td>{{campanha.destinatario}}</td>
            <td>
              <a class="btn btn-xs bg-white" @click="visualizarEmail(campanha.hash)">Visualizar e-mail</a>
            </td>
          </tr>
          <tr v-if="(!campanhas || campanhas.length === 0) && !campanhasLoading">
            <td colspan="4" class="no-borders" style="border-bottom: none"><span
              class="text-danger">Nenhuma comunicação</span>
            </td>
          </tr>
          <tr v-if="campanhasLoading">
            <td colspan="4" class="no-borders text-center" style="border-bottom: none"><i
              class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div v-else>
    <div v-if="campanhasLoading">Verficando se há comunicações importantes...</div>
    <div v-else></div>
  </div>
</template>

<script>
import service from '../../../../domain/arrematantes/services/index'
import EmailView from '../../leiloes/components/includes/EmailView'
import http from '@/utils/services/http'

export default {
  name: 'CampanhasArrematante',
  components: {EmailView},
  props: ['arrematante'],
  data () {
    return {
      campanhasLoading: false,
      campanhas: []
    }
  },
  mounted () {
    if (this.arrematante) {
      this.campanhasLoading = true
      service.getCampanhas(this.arrematante.id)
        .then(({data}) => {
          this.campanhas = data
          this.campanhasLoading = false
        })
        .catch(error => {
          this.campanhasLoading = false
          // alert('Impossível verificar a existência de desistências.')
          console.log(error)
        })
    }
  },
  methods: {
    visualizarEmail (hash) {
      window.open(http.defaults.baseURL + `/api/public/lista-comunicacao-arrematante-hash/${hash}`)
    },
    informarNegativacao (desistencia) {
      this.$refs.emailView.open(
        function () {
          service.gerarEmailInformeNegativacao(desistencia)
            .then((response) => {
              this.bindLoad(response)
              console.log(response)
            })
            .catch((error) => {
              window.responseError(error)
            })
        },
        function (data) {
          return service.enviarEmailInformeNegativacao(desistencia, data)
        }
      )
    }
  }
}
</script>

<style scoped>
td {
  color: #000000 !important;
}

.bg-dark {
  background-color: #ac2925;
  color: #FFFFFF;
}

.bg-black {
  background-color: #eed6d6 !important;
  color: #000000 !important;
}

a {
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// Campanhas.vue?d2a03310